import envConfig from '@scoring-web/configs/env/env.config';
import { ViewRouteConfig } from '@scoring-web/configs/route/route.type';
import { lazy } from 'react';

const LazyUiPlaygroundView = lazy(() => import('./ui-playground.view'));

const uiPlaygroundRoute: Partial<ViewRouteConfig> =
  (envConfig.env === 'development' && {
    lazy: { Component: async () => LazyUiPlaygroundView },
    path: '/ui-playground',
  }) ||
  {};

export default uiPlaygroundRoute;
